import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Rating } from "@mui/material";
import { ENV } from "../../util/Env";
import Loader from "../../util/preloader/Preloader";
import DspFooter from "../events/DspFooter";
import DspHeader from "../events/DspHeader";
import NotificationModal from "../events/NotificationModal";

const SessionFeedback = () => {
  const { Uid } = useParams();
  const { Sid } = useParams();
  const { Kid } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [authStr, setAuthStr] = useState("");
  const [data, setData] = useState([]);
  const [userfeedbackSubmit, setUserfeedbackSubmit] = useState(false);
  const [ratings, setRatings] = useState({}); // Store ratings for each question

  const [feedback, setFeedback] = useState("");
  const maxChars = 500;

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("feedback"); // 'feedback', 'success', 'error'
  const [modalMessage, setModalMessage] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalAction, setModalAction] = useState(null);

  const [uspTemData, setuspTemData] = useState([]);
  useEffect(() => {
    fetchFeedback();
    fetchSingleEvent();
  }, [authStr]);

  const fetchSingleEvent = async () => {
    const url = ENV.API_URL + `web/api/v1/lms-web/website/getEvent/${Sid}`;
    const token = authStr;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: ``,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const results = await response.json();

      setuspTemData(results);
    } catch (error) {
      setModalType("error");
      setModalTitle("Error Loading Event");
      setModalMessage(
        "We are temporarily experiencing technical difficulties. Please try again after sometime",
      );
      setModalAction(() => () => {
        setShowModal(false);
        navigate(`/`);
      });
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllFeedToken = async () => {
    const url = ENV.API_URL + `user/api/v1/lms-user/getOneTimeToken/${Kid}`;
    const token = authStr;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: ``,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const results = await response.text();

      localStorage.setItem("user", results);
      fetchFeedback(results);

      setAuthStr(results);
    } catch (error) {
      // setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchFeedback = async (x) => {
    const url =
      ENV.API_URL +
      `admin/api/v1/lms-admin/feedback/getFeedbackStatus/${Uid}/${Sid}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("result", result);
      if (result.avgScore == null) {
        fetchData(result);
        setUserfeedbackSubmit(false);
      } else {
        setUserfeedbackSubmit(true);
      }
    } catch (error) {
      // setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (x) => {
    const url = ENV.API_URL + `admin/api/v1/lms-admin/feedback/getQuestionList`;
    const token = x;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setData(result);
    } catch (error) {
      // setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRatingChange = (questionId, newRating) => {
    setRatings((prevRatings) => ({
      ...prevRatings,
      [questionId]: newRating,
    }));
  };

  const feedbackSubmission = async () => {
    const url = ENV.API_URL + `admin/api/v1/lms-admin/feedback/submit`;
    const token = authStr;

    // Convert ratings object to array format expected by API
    const ratingsData = Object.keys(ratings).map((questionId) => ({
      questionId: questionId,
      // Safely cast to a Number, multiply by 2, then convert back to a string
      answerPoint: (Number(ratings[questionId]) * 2).toString(),
      answerValue: `${ratings[questionId]} stars`,
    }));

    const payload = {
      sessionId: Sid,
      userId: Uid,
      data: ratingsData,
      userFeedback: feedback,
    };

    setLoading(true);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setModalType("success");
      setModalTitle("Feedback Successfully Submitted");
      setModalMessage(" ");
      setModalAction(() => () => {
        localStorage.removeItem("user");
        setShowModal(false);
        navigate(`/`);
      });
      setShowModal(true);
    } catch (error) {
      setModalType("error");
      setModalTitle("Error Submitting Feedback");
      setModalMessage(
        !error.data
          ? "We are temporarily experiencing technical difficulties. Please try again after sometime"
          : error.data,
      );
      setModalAction(() => () => setShowModal(false));
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTextAreaValue = (value) => {
    if (value.length <= maxChars) {
      setFeedback(value);
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* main page  */}
          <div className="usp_main Feedbackbg">
            {/* Top Navigation Header */}
            <DspHeader />
            <div className="container-lg ">
              <div className="row justify-content-center py-5">
                <div className="d-flex justify-content-center Feedbackbg5">
                  {!userfeedbackSubmit ? (
                    <div className="feedback-main">
                      <h2 className="feedback-title">Event Feedback</h2>
                      <>
                        {data.map((item, index) => {
                          return (
                            <div
                              key={item.id}
                              className="feedback-question-item"
                            >
                              <div className="feedback-question-text">
                                <span className="question-number">
                                  {index + 1}.
                                </span>{" "}
                                {item.question}
                              </div>
                              <div className="feedback-stars">
                                <Rating
                                  value={ratings[item.id] || 0}
                                  onChange={(event, newValue) =>
                                    handleRatingChange(item.id, newValue)
                                  }
                                  size="medium"
                                  sx={{
                                    "& .MuiRating-iconFilled": {
                                      color: "#EFC100 !important",
                                    },
                                    "& .MuiRating-iconHover": {
                                      color: "#FFF3B3 !important",
                                    },
                                    "& .MuiRating-icon": {
                                      fontSize: "24px",
                                      color: "#555555",
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })}

                        <div className="feedback_textarea">
                          <label className="feedback-label">Remark</label>
                          <textarea
                            className="form-control feedback-textarea-input"
                            rows="4"
                            placeholder="Please provide additional feedback here"
                            name="userFeedback"
                            maxLength={maxChars}
                            value={feedback}
                            onChange={(e) =>
                              handleTextAreaValue(e.target.value)
                            }
                          ></textarea>
                        </div>

                        <div className="submit-btn">
                          <button
                            type="button"
                            className="feedback-submit-btn"
                            onClick={() => feedbackSubmission()}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    </div>
                  ) : (
                    <div className="content">
                      <div className="wrapper-1">
                        <div className="wrapper-2">
                          <h1>Thank you for your feedback!</h1>
                          <p>
                            We appreciate your input and want to let you know
                            that your feedback has already been recorded
                          </p>
                          <p> Have a great day.</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Footer */}
            <DspFooter />
          </div>
        </>
      )}

      {/* Notification Modal */}
      <NotificationModal
        isOpen={showModal}
        type={modalType}
        message={modalMessage}
        title={modalTitle}
        onClose={() => {
          if (modalAction) {
            modalAction();
            setModalAction(null);
          } else {
            setShowModal(false);
          }
          setModalMessage("");
          setModalTitle("");
        }}
      />
    </React.Fragment>
  );
};

export default SessionFeedback;
